const segments = ["torget", "travel"];
export const getRole = (participant) => {
    let role = participant.role === 'SELLER' ? 'Seller' : 'Buyer';
    segments.forEach((segment) => {
        if (participant.segmentExternalId.includes(segment)) {
            role = role + " " + segment;
        }
    });
    return role;
};
//# sourceMappingURL=getRole.js.map